import React from 'react';
import { Link } from 'react-router-dom';
import { Clock } from 'lucide-react';
import Reveal from './Reveal';
import { getRecentlyViewed } from '../lib/recentlyViewed';

// A strip of the last few products a shopper peeked at, so they can jump back quickly.
const RecentlyViewed = ({ excludeId, dark = false, title = 'Recently Viewed', subtitle = null }) => {
  const items = getRecentlyViewed().filter((x) => x.id !== excludeId).slice(0, 6);
  if (items.length === 0) return null;

  return (
    <section className={`${dark ? 'bg-[#141311]' : 'bg-[#faf6ef]'} py-14`} data-testid="recently-viewed">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6">
        <Reveal>
          <div className="flex items-center gap-2 mb-1">
            <Clock size={16} className="text-[#c6a15b]" />
            <h2 className={`font-display text-2xl sm:text-3xl ${dark ? 'text-[#f7f3ec]' : 'text-[#1a1a1a]'}`}>{title}</h2>
          </div>
          {subtitle && <p className={`font-body text-sm mb-6 ${dark ? 'text-[#9c9587]' : 'text-[#6b6459]'}`}>{subtitle}</p>}
          {!subtitle && <div className="mb-6" />}
        </Reveal>
        <div className="flex gap-4 overflow-x-auto pb-3 -mx-1 px-1 snap-x">
          {items.map((p, i) => (
            <Reveal key={p.id} delay={i * 0.06}>
              <Link
                to={`/product/${p.id}`}
                data-testid={`recently-viewed-${p.id}`}
                className="group block w-40 sm:w-44 shrink-0 snap-start"
              >
                <div className="aspect-[3/4] bg-[#ece5d8] overflow-hidden rounded-lg">
                  <img src={p.image} alt={p.name} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
                </div>
                <p className={`font-body text-sm mt-2 leading-snug line-clamp-2 ${dark ? 'text-[#f7f3ec]' : 'text-[#1a1a1a]'}`}>{p.name}</p>
                <p className="font-body text-xs text-[#a8823c] mt-0.5">{p.fromPrice ? 'From ' : ''}${Number(p.price).toFixed(2)}</p>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default RecentlyViewed;
